export default __webpack_public_path__ + "static/media/12.ec8f45ce.jpg";